import { EditAliasPayload } from '@repo/accounts-types'
import { ApiResponse } from '@repo/core'
import { AxiosInstance } from 'axios'

export const editAlias = async ({
  api,
  params,
}: {
  api: AxiosInstance
  params: EditAliasPayload
}) => {
  const { alias, id: securitiesAccountId } = params
  const response = await api.put<ApiResponse<void>>(
    `/accounts/securities/${securitiesAccountId}/alias`,
    { alias },
  )
  return response
}

export const editCashAccountsAlias = async ({
  api,
  params,
}: {
  api: AxiosInstance
  params: EditAliasPayload
}) => {
  const { alias, id: cashAccountId } = params
  const response = await api.put<ApiResponse<void>>(
    `/accounts/cash-accounts/${cashAccountId}/alias`,
    { alias },
  )
  return response
}
